import styled from "styled-components";

export const MapContainer = styled("div")(({ theme }) => ({
  border: `1px solid ${theme.colorBorder}`,
  borderRadius: theme.borderRadius,
  overflow: "hidden",
  height: "100%",
  flexGrow: 1,
  width: "100%",
}));
